import { render } from "./Previous.vue?vue&type=template&id=e600d3d6"
import script from "./Previous.vue?vue&type=script&lang=js"
export * from "./Previous.vue?vue&type=script&lang=js"
script.render = render

export default script